<template>
  <slice
    :id="block._key"
    class="slice--products slice--products--grid"
    :class="{
      'slice--products--grid--home': isHome,
      'slice--products--fast-links': block.fast_links,
    }"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div v-if="block.fast_links" class="mb-4">
      <product-bar :products="products" />
    </div>

    <component
      :is="cardComponent(item)"
      v-for="(item, index) in block.lines"
      :key="item._key"
      v-bind="cardAttributes(item, index)"
    />
  </slice>
</template>

<script>
import LineOfLinks from './line/LineOfLinks'

import Slice from '@/components/Slices/Slice'

import ProductCardRefCo from '@/components/Product/CardRefCo'
import ProductBar from '@/components/Product/Bar'

import { instianciateProduct } from '@/entities/sanity/product'

export default {
  name: 'GalleryOfProductsAndLinks',
  components: {
    Slice,
    ProductBar,
  },
  props: {
    block: {
      type: Object,
      required: true,
    },
    firstBlock: {
      type: Boolean,
      default: false,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    products() {
      if (this.block.fast_links) {
        return this.block.lines
          .filter((line) => line._type === 'aLineOfOneProductAndHisColors')
          .map((line) => line.product)
          .filter((p) => p.uid)
      }

      return []
    },
  },
  methods: {
    cardComponent(item) {
      if (item._type === 'aLineOfOneProductAndHisColors') {
        if (item.product.uid) {
          return ProductCardRefCo
        }
      }

      if (item._type === 'lineOfLinks') {
        return LineOfLinks
      }

      return 'div'
    },
    cardAttributes(item, index) {
      if (item._type === 'lineOfLinks') {
        return {
          links: item.links,
          block: {
            renderAs: item.render_as,
            gallery: item.gallery,
            gallery_mobile: item.gallery_mobile,
          },
          isFirst: this.firstBlock && index === 0,
          isHome: this.isHome,
        }
      }
      if (item._type === 'aLineOfOneProductAndHisColors') {
        return {
          productDocument: instianciateProduct(item.product),
          gallery: item.gallery,
          galleryMobile: item.gallery_mobile,
          colorsOrder: item.colors,
          isFirst: this.firstBlock && index === 0,
        }
      }

      return {}
    },
  },
}
</script>
